import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

  const exportToExcel = (data, columns, fileName = "Table.xlsx") => {
    // Extract column headers
    const headers = columns.map((col) =>
      typeof col === "string" ? col : col.label
    );

  
     const worksheet = XLSX.utils.json_to_sheet(
    data.map((row) =>
      headers.reduce((acc, header, i) => {
        const colKey = typeof columns[i] === "string" ? columns[i] : columns[i].name;
        const value = row[colKey];

        //  Force everything to string
        acc[header] = value !== null && value !== undefined ? String(value) : "";
        return acc;
      }, {})
    )
  );

      worksheet["!cols"] = headers.map(() => ({ wch: 20 })); // default 20 chars width

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save as file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    saveAs(dataBlob, fileName);
  };

  export default exportToExcel
